export default __webpack_public_path__ + "static/media/social.115d45fd.svg";